import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  returnListParams,
  returnListQueryOptions,
  returnListSearchSchema,
  ReturnsPage,
} from '@/features/returns';

export const Route = createFileRoute('/_authed/_active/s/$storeId/returns/')({
  staticData: { tours: ['returns.list'] },
  validateSearch: returnListSearchSchema,
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'orders.read');
  },
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...returnListQueryOptions(params.storeId, returnListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // Filter, sort and page changes on the list itself must not wait for the fetch, or a second
    // pick in the filter builds on the stale URL; the page shows the previous rows meanwhile.
    if (cause !== 'stay') await prefetch;
  },
  component: ReturnsPage,
});
